import { FC, ReactNode } from 'react';
import { styled } from 'styled-components';
import TopBar from '@/components/top-bar';

interface PageLayoutProps {
	children?: ReactNode;
}

const PageLayout: FC<PageLayoutProps> = ({ children }) => (
	<Container>
		<TopBar />

		<Content>{children}</Content>

		<br />
	</Container>
);

const Container = styled.div`
	height: 100%;
	width: 100%;
`;

const Content = styled.div`
	padding: 0 40px;
`;

export default PageLayout;
